import React, { Component, useState } from 'react';
import ReactDOM from "react-dom";
import { Icon } from 'semantic-ui-react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import CardCursoDragNDrop from './CardCursoDragNDrop';
import CarouselMoveButton from './CarouselMoveButton';
import './styles.css';

export default class CarouselDragNDrop extends Component {
    constructor(props) {
        super(props);

        this.state = {
            faixaOptions: [],
            cursos: {},
            carousel: {
                index: 0,
                perPage: 4,
                size: 0,
            },
            
            isLoading: true,
        }
    }

    moveCarousel = (direction) => {
        const { carousel } = this.props;

        if(direction == 'right') {
            if(carousel.index + carousel.perPage < carousel.size) {
                carousel.index += 1;

                this.setState({ carousel });
            }
        } else {
            if(carousel.index>0) {
                carousel.index -= 1;

                this.setState({ carousel });
            }
        }
    }

    handleCardDragEnd = (result) => {
        if(!result.destination) return;
        
        const { cursos } = this.props;
        const { source, destination } = result;
        const [removed] = cursos.value.splice(source.index, 1);

        cursos.value.splice(destination.index, 0, removed);
        
        this.setState({ cursos });
    }

    render(){
        const { cursos, carousel, faixaOptions } = this.props;
        
        return(  
            <div className="painel-carrosseis_slider-carousel">
                <CarouselMoveButton moveCarousel={this.moveCarousel}  direction="left" />
                <CarouselMoveButton moveCarousel={this.moveCarousel}  direction="right" />
                
                <DragDropContext onDragEnd = { result => this.handleCardDragEnd(result)}>
                    <Droppable droppableId={'column1'} key={'column1'} direction='horizontal'>
                        {(provided, snapshot) => {
                            return (
                                <div id='painel-carrosseis_hider-carousel'>
                                    <div 
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}    
                                        id="painel-carrosseis_main-working-carousel" 
                                        style={{
                                            left: carousel.index*(-260) + 'px',
                                            width: 260*cursos.value.length+1 + 'px',
                                        }} 
                                        className="painel-carrosseis_working-carousel"
                                    >
                                        {cursos.value.map((curso, index) => {
                                            return (
                                                <Draggable key={curso.id} draggableId={curso.id} index={index}>
                                                    {(provided, snapshot) => {
                                                        return (
                                                            <CardCursoDragNDrop 
                                                                provided = { provided }
                                                                snapshot = { snapshot }
                                                                curso = { curso }
                                                                cursoIndex = { index }
                                                                carouselIndex = { carousel.index }
                                                                faixaOptions = { faixaOptions }
                                                                changeTextFaixa = { this.props.changeTextFaixa }
                                                                changeFaixaColor = { this.props.changeFaixaColor }
                                                                removeCurso = { this.props.removeCurso }
                                                                changeValorCarousel = { this.props.changeValorCarousel }
                                                            />
                                                        );
                                                    }}
                                                </Draggable>
                                            );
                                        })}
                                        {provided.placeholder}
                                    </div>
                                </div>
                            );
                        }}
                    </Droppable>
                </DragDropContext>
            </div>
        )
    }
}